import { useHeaders } from "hooks/api/useHeaders";
import { useQuery, useQueryCache } from "react-query";
import { getMaterialSpecAssetsReq } from "api/assets";
import { Asset, buildAssetViewModel } from "api/factories";

export const useMaterialSpecAssets = (
    { isPrinted, materialSpecId, materialId }: { isPrinted: boolean; materialSpecId?: number; materialId?: number },
    useCache = false
) => {
    const headers = useHeaders();
    const previousAssets = useQueryCache();

    return useQuery(["assets", isPrinted ? materialSpecId : materialId], () => {
        if (useCache) {
            const asset = previousAssets.getQueryData<Asset[]>(["assets", isPrinted ? materialSpecId : materialId]);

            if (asset) {
                return asset;
            }
        }

        return buildAssetViewModel(getMaterialSpecAssetsReq(headers, materialSpecId, materialId));
    });
};
